import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

const VersioningPropertiesList = ({ value, options = {} }) => {
  const list = Array.isArray(value) ? value : [value];
  const isNotFlattened = list.some((obj) => typeof obj !== 'string');
  const flattenedValues = isNotFlattened ? list.map((item) => item[options.labelKey]) : list;

  return (
    <Typo variant="b01" color="secondary">
      {flattenedValues.join(options.delimiter)}
    </Typo>
  );
};

VersioningPropertiesList.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])).isRequired,
  options: PropTypes.shape({
    delimiter: PropTypes.string,
    labelKey: PropTypes.string,
  }),
};

export default React.memo(VersioningPropertiesList);
